// @ts-nocheck
const originalUpdateText = PIXI.Text.prototype.updateText;

declare module 'pixi.js' {
    export interface Text {
        maxWidth?: number;
        maxHeight?: number;
        maxFontSize?: number;
    }
}

PIXI.Text.prototype.updateText = function(respectDirty) {
    if (this.localStyleID !== this._style.styleID) this.dirty = true;

    if (this.dirty && this.maxWidth && this.maxHeight) {
        this.maxFontSize = this.maxFontSize || this.style.fontSize;
        this.style.wordWrapWidth = this.maxWidth;
        this.style.fontSize = this.maxFontSize;
        let adjusted = false;

        while (true) {
            const measured = PIXI.TextMetrics.measureText(
                this.text || ' ',
                this.style,
                this.style.wordWrap,
                this.canvas
            );

            if (
                this.style.fontSize === 1 ||
                (measured.width <= this.maxWidth &&
                    measured.height <= this.maxHeight)
            )
                break;

            if (this.style.wordWrap || adjusted) {
                this.style.fontSize -= 1;
            } else {
                const scale = Math.min(
                    this.maxWidth / measured.width,
                    this.maxHeight / measured.height
                );
                const size = this.style.fontSize * scale;
                this.style.fontSize = Math.max(1, Math.floor(size));
            }

            adjusted = true;
        }
    }

    return originalUpdateText.call(this, respectDirty);
};
